import { useEffect } from "react";
import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";


const MoleculeCheckBox = ({ label, tooltip, value, onChange }) => {
    const uniqueId = uuidv4();
    useEffect(() => {
        // console.log('MoleculeCheckBox', label, value)
    }, [value])
    return (
        <Col className="text-start">
            <Form.Group controlId={`checkbox-${uniqueId}`} className="d-flex flex-row align-items-center">
                {/* Icon Info với Tooltip */}
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{tooltip}</Tooltip>}
                >
                    <InfoCircle className="me-1 mb-1 text-primary" style={{ cursor: "pointer", fontSize: "16px", minWidth: "16px" }} />
                </OverlayTrigger>
                <Form.Check
                    type="checkbox"
                    label={label}
                    checked={value == false ? false : true}
                    onChange={(e) => onChange(e.target.checked)}
                />

            </Form.Group>
        </Col>
    );
};

export default MoleculeCheckBox